import { Brand, RemoteData } from '@common/util-models';
import { createSelector } from '@ngrx/store';
import { BrandsByApplianceState } from '@sky/util-models';

import { CatalogState } from '../catalog.reducer';
import { getCatalogState } from '../catalog.selectors';

export const getBrandsByApplianceState = createSelector(
  getCatalogState,
  (state: CatalogState) => state.brandsByAppliance
);

export const getBrandName = (props: {
  applianceCode: string;
  brandCode: string;
}) =>
  createSelector(
    getBrandsByApplianceState,
    (brandsState: BrandsByApplianceState): Brand | undefined => {
      return brandsState[props.applianceCode]?.brands.find(
        (brand: Brand) => brand.code === props.brandCode
      );
    }
  );

export const getBrandRemoteState = (props: { applianceCode: string }) =>
  createSelector(
    getBrandsByApplianceState,
    (brandsState: BrandsByApplianceState): RemoteData | undefined => {
      return brandsState[props.applianceCode]?.remoteState;
    }
  );

export const getBrandByDescription = (props: {
  applianceCode: string;
  brandDescription: string;
}) =>
  createSelector(
    getBrandsByApplianceState,
    (brandsState: BrandsByApplianceState): Brand | undefined => {
      return brandsState[props.applianceCode]?.brands.find(
        (brand: Brand) =>
          brand.description.toLowerCase() ===
          props.brandDescription.toLowerCase()
      );
    }
  );
